type IStorage = {
  interComConfig: Record<string, any>
  i18nextLng: string
}

class StorageUtil {
  get<K extends keyof IStorage>(key: K): IStorage[K] {
    const data = localStorage.getItem(key)

    if (!data) return null

    try {
      const parseData = JSON.parse(data)
      return parseData
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('parse localStorage error, key is ', key)
      return null
    }
  }

  set<K extends keyof IStorage>(key: K, data: IStorage[K]) {
    // 不允许存储undefined，因为无法正确JSON.parse
    if (data === undefined) return
    localStorage.setItem(key, !!data ? JSON.stringify(data) : '')
    return true
  }

  remove(key: keyof IStorage) {
    localStorage.removeItem(key)
    return true
  }
}

export default new StorageUtil()
